(function () {
  var BRAND_LOCATION = 'Santa Catarina - Brasil';
  var TIMEZONE = 'America/Sao_Paulo';
  var TZ_ABBR = 'BRT';

  /* ── Force compact menu: hide inline nav, show hamburger ── */
  function enforceCompactMenu() {
    var headerMenu = document.querySelector('#header-component header-menu.header-menu');
    if (headerMenu) {
      headerMenu.style.setProperty('display', 'none', 'important');
    }

    var drawer = document.querySelector('#header-component .header__drawer');
    if (drawer) {
      drawer.style.setProperty('display', 'flex', 'important');
    }
  }

  /* ── Brand meta: localização | dia mês ordinal, HH:MM TZ (desktop only) ── */
  function ordinal(n) {
    if (n > 3 && n < 21) return n + 'th';
    switch (n % 10) {
      case 1: return n + 'st';
      case 2: return n + 'nd';
      case 3: return n + 'rd';
      default: return n + 'th';
    }
  }

  function initBrandMeta() {
    // No modo drawer o Horizon aplica display:contents nas colunas, então o elemento
    // existe no DOM mas não gera caixa de layout. Preferimos o header__columns nesse caso.
    var headerComp = document.getElementById('header-component');
    if (!headerComp) return;
    if (headerComp.querySelector('.header-brand-meta')) return;

    var drawerMode = headerComp.getAttribute('data-menu-style') === 'drawer'
      || getComputedStyle(headerComp.querySelector('.header__column--left') || document.body).display === 'contents';

    var leftCol = drawerMode
      ? headerComp.querySelector('.header__columns')
      : headerComp.querySelector('.header__column--left');

    if (!leftCol) leftCol = headerComp.querySelector('.header__column--left') || headerComp.querySelector('.header__columns');
    if (!leftCol) return;

    var wrap = document.createElement('div');
    wrap.className = 'header-brand-meta';

    var loc = document.createElement('span');
    loc.className = 'hbm-location';
    loc.textContent = BRAND_LOCATION;

    var sep = document.createElement('span');
    sep.className = 'hbm-sep';
    sep.textContent = ' | ';

    var dt = document.createElement('span');
    dt.className = 'hbm-datetime';

    wrap.appendChild(loc);
    wrap.appendChild(sep);
    wrap.appendChild(dt);
    leftCol.appendChild(wrap);

    function tick() {
      var now = new Date();
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: TIMEZONE,
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).formatToParts(now);

      var p = {};
      parts.forEach(function (part) { p[part.type] = part.value; });

      var str = p.weekday + ' ' + p.month + ' ' + ordinal(parseInt(p.day)) + ', ' + p.hour + ':' + p.minute + ' ' + TZ_ABBR;
      dt.textContent = str;
    }

    tick();
    setInterval(tick, 30000);
  }

  /* ── Drawer: esconde produtos e injeta Balddoria Community newsletter ── */
  function initDrawerCommunity() {
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer) return;
    if (drawer.querySelector('.drawer-community')) return;

    // Esconde containers de produtos featured (walk up para o filho direto do drawer)
    var productEls = drawer.querySelectorAll('product-card, [class*="product-card"], [class*="featured-product"], slider-component, scroll-area');
    var hidden = new Set();
    productEls.forEach(function (el) {
      var node = el;
      while (node && node.parentElement && node.parentElement !== drawer) {
        node = node.parentElement;
      }
      if (node && node !== drawer && !hidden.has(node)) {
        node.style.setProperty('display', 'none', 'important');
        hidden.add(node);
      }
    });

    // Injeta bloco community
    var block = document.createElement('div');
    block.className = 'drawer-community';
    block.innerHTML =
      '<span class="drawer-community__title">Balddoria Community</span>' +
      '<form class="drawer-community__form" novalidate>' +
        '<input type="email" class="drawer-community__input" placeholder="YOUR@EMAIL.COM" autocomplete="email" required>' +
        '<button type="submit" class="drawer-community__submit" aria-label="Subscribe">&#8594;</button>' +
      '</form>' +
      '<p class="drawer-community__success">Thank you &#8212; you&#8217;re in.</p>';

    drawer.appendChild(block);

    var form = block.querySelector('.drawer-community__form');
    var success = block.querySelector('.drawer-community__success');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input');
      if (!input.value || !input.validity.valid) return;

      var data = new FormData();
      data.append('form_type', 'customer');
      data.append('utf8', '✓');
      data.append('contact[email]', input.value);
      data.append('contact[tags]', 'newsletter');

      fetch('/contact', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
        .finally(function () {
          form.style.display = 'none';
          success.style.display = 'block';
        });
    });
  }

  function init() {
    enforceCompactMenu();
    initBrandMeta();
    initDrawerCommunity();
  }

  function retry() {
    enforceCompactMenu();
    // Re-add se o componente do header removeu o elemento
    var existing = document.querySelector('#header-component .header-brand-meta');
    if (!existing) initBrandMeta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setTimeout(retry, 400);
  setTimeout(retry, 1200);
  setTimeout(retry, 3000);

  // Garante community block mesmo se o drawer renderizar tarde
  setTimeout(initDrawerCommunity, 800);
  setTimeout(initDrawerCommunity, 2500);

  // Garante que o brand meta persiste se o header-component re-renderizar
  document.addEventListener('DOMContentLoaded', function () {
    var headerEl = document.getElementById('header-component');
    if (!headerEl || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (!headerEl.querySelector('.header-brand-meta')) {
        initBrandMeta();
      }
    }).observe(headerEl, { childList: true, subtree: true });
  });
})();
